import {config} from '../config'

export const appRoutes = {}
export const redirectHomeRefreshPaths = [];

const rootState = `/${config.app.rootState}`
const isAifeRoute = (pathname) => pathname === rootState || pathname.startsWith(`${rootState}/`)

export const isAppRoute = (pathname = window.location.pathname, appName = 'outof195') => {
    if (appName === 'aife') return isAifeRoute(pathname)
    if (appName === 'outof195') return !isAifeRoute(pathname)
    return appRoutes[appName]?.some(route => pathname.startsWith(route)) || false
}
